import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { removeEncounter } from '../../store/actions/encounter';
import { AlertIcon, BinIcon } from '../../../../icons';
import { ModalComponent } from '../baseComponents';
import { useAuth } from '@frontegg/react';
import { analytics } from 'src/services';

//This is to show remove encounter pop-up
const DeleteEncounter = ({
  schedulepage,
  encounterDetailsSlice,
  storedParams,
}) => {
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const { user } = useAuth();

  const handleRemoveEncounter = () => {
    setSubmitLoading(true);
    if (schedulepage) {
      analytics.track('Removed Encounter In Ambient Encounters List From VCA', {
        email: user?.email,
      });
    } else {
      analytics.track(
        'Removed Encounter In Ambient Encounters List From Aura',
        { email: user?.email }
      );
    }
    if (isModalVisible) {
      dispatch(
        removeEncounter(
          encounterDetailsSlice?.encounter_id,
          storedParams,
          setSubmitLoading
        )
      );
    }
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setSubmitLoading(false);
    if (schedulepage) {
      analytics.track(
        'Clicked Cancel After Clicking Remove Encounter In Ambient Encounters List From VCA',
        { email: user?.email }
      );
    } else {
      analytics.track(
        'Clicked Cancel After Clicking Remove Encounter In Ambient Encounters List From Aura',
        { email: user?.email }
      );
    }
    setIsModalVisible(false);
  };

  return (
    <>
      <a
        className="ant-dropdown-link"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsModalVisible(true);
        }}
      >
        <BinIcon />
      </a>
      <ModalComponent
        centered={true}
        open={isModalVisible}
        handleSubmit={handleRemoveEncounter}
        handleCancel={handleCancel}
        submitButtonText="Delete"
        cancelButtonText="Cancel"
        closable={false}
        className="!w-fit"
        submitLoading={submitLoading}
        additionalBody={
          <>
            {' '}
            <div className="text-black font-sans font-medium text-lg flex justify-center items-center gap-2">
              <span>
                {' '}
                <AlertIcon />
              </span>
              <p>
                This will permanently delete the encounter. Are you sure you
                want to delete?
              </p>
            </div>
          </>
        }
      />
    </>
  );
};

export default DeleteEncounter;
